// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error-message-container{padding-top:2.8125rem}.content-box{width:100%}", "",{"version":3,"sources":["webpack://src/Pages/Products/Styles/_ProductDetail.scss"],"names":[],"mappings":"AAAA,yBACE,qBAAA,CAEF,aACE,UAAA","sourcesContent":[".error-message-container {\n  padding-top: 2.8125rem;\n}\n.content-box {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
